import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["dataMark", "__attributes", "__classNames", "custom", "onChange"];
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import classNames from 'classnames';
import { EVisualSize } from './types';
import * as styles from './input.css';
var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);
  var _super = _createSuper(Input);
  function Input() {
    var _this;
    _classCallCheck(this, Input);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      var onChange = _this.props.onChange;
      onChange(e, e.currentTarget.value);
    });
    return _this;
  }
  _createClass(Input, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$dataMark = _this$props.dataMark,
        dataMark = _this$props$dataMark === void 0 ? 'Input' : _this$props$dataMark,
        _this$props$__attribu = _this$props.__attributes,
        __attributes = _this$props$__attribu === void 0 ? {} : _this$props$__attribu,
        _this$props$__classNa = _this$props.__classNames,
        __classNames = _this$props$__classNa === void 0 ? '' : _this$props$__classNa,
        _this$props$custom = _this$props.custom,
        custom = _this$props$custom === void 0 ? {} : _this$props$custom,
        onChange = _this$props.onChange,
        sharedProps = _objectWithoutProperties(_this$props, _excluded);
      var size = custom.size,
        invalid = custom.invalid,
        _custom$Input = custom.Input,
        _Input = _custom$Input === void 0 ? 'input' : _custom$Input;
      var sharedStyles = classNames(styles['input'], invalid && styles['invalid'], size === EVisualSize.DESKTOP && styles['desktop'], size === EVisualSize.MOBILE && styles['mobile'], __classNames);
      return /*#__PURE__*/React.createElement(_Input, _extends({}, __attributes, sharedProps, {
        "data-mark": dataMark,
        onChange: this.onChange,
        className: sharedStyles
      }));
    }
  }]);
  return Input;
}(React.Component);
export { Input, EVisualSize };